export const nav_home = "Home";
export const nav_about = "About Us";
export const nav_services = "Services";
export const nav_gallery = "Gallery";
export const nav_contact = "Contact";

export const hero_badge = "PROFESSIONAL WELDING";
export const hero_title_1 = "Joining Quality and Precision,";
export const hero_title_2 = "we weld";
export const hero_title_3 = "your projects";
export const hero_title_4 = "with excellence";
export const hero_subtitle = "Experts in Industrial Welding and Metal Fabrication with over 15 years of experience";
export const hero_btn_gallery = "VIEW PROJECTS";
export const hero_btn_quote = "Request Your Quote";

export const about_label = "OUR STORY";
export const about_title = "Who We Are";
export const about_text_1 = "AbrilWeldWorksPro LLC is a leading company in industrial welding and metal fabrication, with over 15 years of experience in the sector. We specialize in providing high-quality solutions for industrial, commercial, and residential projects.";
export const about_text_2 = "Our commitment is to provide exceptional services with the highest standards of quality, safety, and precision. Each project is unique and we are dedicated to exceeding our clients' expectations with artisanal and professional work.";
export const about_stat_1 = "Years of Experience";
export const about_stat_2 = "Completed Projects";
export const about_stat_3 = "Client Satisfaction";

export const services_title = "Our Services";
export const services_subtitle = "We offer a wide range of welding and metal fabrication services to meet all your needs";
export const service_1_title = "MIG Welding";
export const service_1_desc = "High-precision welding with MIG and TIG technology for industrial and commercial work of the highest quality.";
export const service_2_title = "Metal Structure Fabrication";
export const service_2_desc = "Design and construction of custom metal structures for industrial, commercial, and residential projects.";
export const service_3_title = "Industrial Repair and Maintenance";
export const service_3_desc = "Specialized repair and preventive maintenance services for industrial metal equipment and structures.";
export const service_btn_more = "MORE INFO";
export const service_available = "Consultation available";

export const gallery_title = "Our Work";
export const gallery_subtitle = "Explore some of our most outstanding projects";
export const gallery_btn_all = "VIEW ALL PROJECTS";

export const contact_title = "Contact Us";
export const contact_subtitle = "We are here to help you with your next project";
export const contact_phone = "Phone";
export const contact_email = "Email";
export const contact_address = "Address";
export const contact_hours = "Hours";
export const contact_hours_value = "Mon - Fri: 8:00 AM - 6:00 PM";
export const contact_qr_title = "Scan to Contact via WhatsApp";
export const contact_spanish = "Spanish";
export const contact_english = "English";

export const footer_tagline = "Superior quality professional welding";
export const footer_quick_links = "Quick Links";
export const footer_services_title = "Services";
export const footer_contact_title = "Contact";
export const footer_rights = "All rights reserved.";
export const footer_powered = "Powered by Readdy";

export const modal_language_title = "In which language do you prefer assistance?";
export const modal_language_subtitle = "Select your preferred language to continue";
export const modal_cancel = "Cancel";

export default {
  nav_home,
  nav_about,
  nav_services,
  nav_gallery,
  nav_contact,
  hero_badge,
  hero_title_1,
  hero_title_2,
  hero_title_3,
  hero_title_4,
  hero_subtitle,
  hero_btn_gallery,
  hero_btn_quote,
  about_label,
  about_title,
  about_text_1,
  about_text_2,
  about_stat_1,
  about_stat_2,
  about_stat_3,
  services_title,
  services_subtitle,
  service_1_title,
  service_1_desc,
  service_2_title,
  service_2_desc,
  service_3_title,
  service_3_desc,
  service_btn_more,
  service_available,
  gallery_title,
  gallery_subtitle,
  gallery_btn_all,
  contact_title,
  contact_subtitle,
  contact_phone,
  contact_email,
  contact_address,
  contact_hours,
  contact_hours_value,
  contact_qr_title,
  contact_spanish,
  contact_english,
  footer_tagline,
  footer_quick_links,
  footer_services_title,
  footer_contact_title,
  footer_rights,
  footer_powered,
  modal_language_title,
  modal_language_subtitle,
  modal_cancel
};